package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.addPathNodes
import androidx.compose.ui.unit.dp
import compose.assets.Svg

// Material Design Icons: arrow-top-right
public val Svg.Arrow_top_right: ImageVector
    get() {
        if (_arrow_top_right != null) {
            return _arrow_top_right!!
        }
        _arrow_top_right = ImageVector.Builder(
            name = "Arrow_top_right",
            defaultWidth = 24.0.dp,
            defaultHeight = 24.0.dp,
            viewportWidth = 24.0f,
            viewportHeight = 24.0f
        ).addPath(
            pathData = addPathNodes("M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z"),
            fill = SolidColor(Color(0xFF000000))
        ).build()
        return _arrow_top_right!!
    }

private var _arrow_top_right: ImageVector? = null
